import { backfaceFixed } from "./backfaceFixed";
import { manageEventListeners } from "./manageEventListeners";
import { waitModalAnimation } from "./waitModalAnimation";

export const closeModal = async (modal) => {
  let isTransitioning = false;
  let currentOpenTrigger = null;

  if (isTransitioning) return;

  // eslint-disable-next-line no-useless-assignment
  isTransitioning = true;
  modal.setAttribute("data-active", "false");
  backfaceFixed(false);
  manageEventListeners(modal, false);

  await waitModalAnimation(modal);
  modal.close();

  if (currentOpenTrigger) {
    currentOpenTrigger.focus();
    // eslint-disable-next-line no-useless-assignment
    currentOpenTrigger = null;
  }

  // eslint-disable-next-line no-useless-assignment
  isTransitioning = false;
};
